<template>
    <div class="form-group bs-form-group">
        <label :for="name" class="text-uppercase mb-0">{{ label }}</label>
        <div class="editor">
            <editor-menu-bubble :editor="editor" :keep-in-bounds="keepInBounds" v-slot="{ commands, isActive, menu }">
                <div
                        class="menububble"
                        :class="{ 'is-active': menu.isActive }"
                        :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
                >
                    <bs-action :icon="['fas', 'bold']" class="menububble__button btn-info mr-1" :class="{ 'is-active': isActive.bold() }" @click="commands.bold"></bs-action>
                    <bs-action :icon="['fas', 'italic']" class="menububble__button btn-info mr-1" :class="{ 'is-active': isActive.italic() }" @click="commands.italic"></bs-action>

                </div>
            </editor-menu-bubble>

            <editor-content class="editor__content form-control shadow-sm border-top-0 border-left-0 border-bottom-1" :editor="editor" />
        </div>
    </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBubble } from 'tiptap'
import {
  BulletList, HardBreak, Heading, ListItem, OrderedList, Bold, Code, Italic, Link, Strike, Underline,
  Placeholder
} from 'tiptap-extensions'

export default {
  name: 'Comment',
  props: ['label', 'name', 'help', 'value', 'error'],
  components: {
    EditorContent,
    EditorMenuBubble
  },
  data () {
    return {
      keepInBounds: true,
      editor: new Editor({
        extensions: [new BulletList(), new HardBreak(), new Heading({ levels: [1, 2, 3] }), new ListItem(),
          new OrderedList(), new Link(), new Bold(), new Code(), new Italic(), new Strike(), new Underline(),
          new Placeholder({
            emptyEditorClass: 'is-editor-empty',
            emptyNodeClass: 'is-empty',
            showOnlyWhenEditable: true,
            showOnlyCurrent: true
          })
        ],
        onUpdate: ({ getHTML }) => {
          this.$emit('input', getHTML())
        }
      })
    }
  },
  mounted () {
    this.editor.setContent(this.value)
  },
  beforeDestroy () {
    this.editor.destroy()
  },
  methods: {
    submit () {
      this.$emit('submit', this.editor.getHTML())
      this.editor.clearContent()
    }
  }
}
</script>

<style lang="scss">
    .editor p.is-editor-empty:first-child::before {
        content: attr(data-empty-text);
        float: left;
        color: #aaa;
        pointer-events: none;
        height: 0;
    }

    .editor__content {
        font-weight: 400;
        height: auto;

        > div {
            min-height: 160px;
        }
    }

    .ProseMirror:focus {
        outline: none;
    }

    .menububble {
        position: absolute;
        visibility: hidden;
        display: flex;
        z-index: 20;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 0.2s, visibility 0.2s;

        &.is-active {
            visibility: visible;
            opacity: 1;
        }
    }
</style>
